import { Grid } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { connect } from "react-redux";
import { getBookingOverview } from "../../actions/GenomicsResearchAction";
import React, { useEffect, useState } from 'react';
// import "./dashboard.css";
import SunilKumar from './sunilkumar.jpeg'
import logo from './bayer.png'
import redLogo from '../../../dr.jpg'
import drLogo from '../../../redlogo.png'
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        card: {
            height: "100%",
            padding: "20px",
        },
        cardContent: {
            textAlign: "center",
        },
        center: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        text: { color: "black" },
    })
);


interface Props {
    getBookingOverview: any;
    bookingoverview: any;
    userDetails: any;
    loading: any
}

const Dashboard: React.FC<Props> = ({
    getBookingOverview,
    bookingoverview,
    loading,
}) => {
    const classes = useStyles();
    const [showWelcomePage, setShowWelcomePage] = useState(true);
    useEffect(() => {
        const sessionData = sessionStorage.getItem('showWelcomePage');

        if (sessionData !== 'true') {
            setShowWelcomePage(true);
            sessionStorage.setItem('showWelcomePage', 'true');
        }
    }, []);

    useEffect(() => {
        return () => {
            sessionStorage.removeItem('showWelcomePage');
        };
    }, []);

    return (
        <>
            {showWelcomePage ? (
                <div style={{ width: "100%", margin: "60px auto" }}>
                    <div style={{ border: "2px solid #0b2857", borderRadius: "10px" }}>
                        <div style={{ padding: "10px", color: "black" }}>
                            <Grid container>
                                <Grid item xs={12} md={4}>
                                    <img src={drLogo} alt="Sunil Kumar" style={{ width: '30%' }} />
                                </Grid>
                                <Grid item xs={12} md={5}>
                                    <h2 style={{ textAlign: "center" }}>Welcome Dr. Ravi</h2>
                                    <h4 style={{ textAlign: "center" }}>Rice Genome Design Scientist</h4>
                                </Grid>
                                <Grid item xs={7} style={{ marginTop: "10px" }}>
                                    <div>
                                        <h2>About Dr. Ravi</h2>
                                        <p style={{ fontSize: "18px" }}>
                                            Dr. Ravi is a renounced plant scientist having two decades of experience in crop science & applications. Previously we was associated to Monsanto, DRR and ICRISAT. He is a PhD in Plant science from Eidgenössische Technische Hochschule Zürich.
                                        </p>
                                        <h4 style={{ marginTop: "20px" }}>Education and Credentials:</h4>
                                        <ul style={{ fontSize: "18px" }}>
                                            <li>Eidgenössische Technische Hochschule ZürichDoctor of Philosophy (Ph.D.)Plant Sciences
                                                2002 - 2010.</li>
                                            <li>University of Agricultural Sciences, DharwadMaster of Science (M.Sc.)Agricultural genetics and breeding
                                                2000 - 2002
                                            </li>
                                            <li>University of Agricultural Sciences, DharwadBachelor of Science (B.S.)Agriculture, General
                                                1996 - 2000</li>
                                        </ul>
                                    </div>
                                </Grid>
                                <Grid item xs={1}>

                                </Grid>
                                <Grid item xs={4}>
                                    <img src={redLogo} alt="Sunil Kumar" style={{ width: '80%' }} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </div>
            ) : (
                <div style={{ width: "100%", margin: "60px auto" }}>
                    <div style={{ backgroundColor: "#0b2857", border: "2px solid #0b2857", borderRadius: "10px" }}>
                        <h2 style={{ textAlign: "center", color: "white" }}>MY DASHBOARD</h2>
                    </div>

                    <div style={{ margin: "10px 0px 0px 0px" }} id="geno">
                        <div className="cardsAppointment">
                            <div>
                                <Grid container>
                                    <Grid item sm={12}>
                                        <a href="/dashboard/gnre/genom_samples_count" style={{ textDecoration: 'none' }}>
                                            <h5 style={{ color: "#ffffff", fontWeight: 'bold' }}>2022-2023</h5>
                                            <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Completed Project Count: 1</span><br />
                                            <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Completed Sample Count: 600</span><br />
                                        </a>
                                    </Grid>
                                </Grid>
                            </div>
                            <div>
                                <Grid container>
                                    <Grid item sm={12}>
                                        <h5 style={{ color: "#ffffff", fontWeight: 'bold' }}>2021-2022</h5>
                                        <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Completed Project Count: 40</span><br />
                                        <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Completed Sample Count: 560</span><br />
                                    </Grid>
                                </Grid>
                            </div>
                            <div>
                                <Grid container>
                                    <Grid item sm={12}>
                                        <h5 style={{ color: "#ffffff", fontWeight: 'bold' }}>2020-2021</h5>
                                        <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Completed Project Count: 47</span><br />
                                        <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Completed Sample Count: 780</span><br />
                                    </Grid>
                                </Grid>
                            </div>
                            <div>
                                <Grid container>
                                    <Grid item sm={12}>
                                        <h5 style={{ color: "#ffffff", fontWeight: 'bold' }}>2019-2020</h5>
                                        <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Completed Project Count: 47</span><br />
                                        <span style={{ color: "#ffffff", fontWeight: 'bold' }}>Completed Sample Count: 780</span><br />
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

const mapStateToProps = (state: any) => ({
    bookingoverview: state.GenomicsCAReducer.bookingoverview,
    loading: state.GenomicsCAReducer.loading,
});

export default connect(mapStateToProps, {
    getBookingOverview,
})(Dashboard);